import CryptoJS from 'crypto-js'

export async function uploadToMinio(file, config) {
  const {
    bucket,
    endpoint,
    port,
    region,
    accessKey,
    secretKey,
    dirName,
    protocol,
  } = config

  let newFile = file
  if (file) {
    const timestamp = Date.now()
    const ext = file.name.split('.').pop()
    const base = file.name.replace(/\.[^/.]+$/, '')
    const safeBase = base.replace(/\s+/g, '-').replace(/[()]/g, '')
    const name = `${safeBase}_${timestamp}.${ext}`
    newFile = new File([file], name, { type: file.type })
  }

  const arrayBuffer = await newFile.arrayBuffer()
  const wordArray = CryptoJS.lib.WordArray.create(arrayBuffer)
  const payloadHash = CryptoJS.SHA256(wordArray).toString(CryptoJS.enc.Hex)
  const now = new Date()
  const amzDate = now.toISOString().replace(/[-:]/g, '').replace(/\.\d+Z$/, 'Z')
  const dateStamp = amzDate.substring(0, 8)
  const host = port ? `${endpoint}:${port}` : endpoint
  const rawKey = dirName ? `${dirName}/${newFile.name}` : newFile.name
  const encodedKey = encodeURIComponent(rawKey).replace(/%2F/g, '/')
  const canonicalUri = `/${bucket}/${encodedKey}`
  const contentType = newFile.type || 'application/octet-stream'
  const canonicalHeaders =
    `content-type:${contentType}\n` +
    `host:${host}\n` +
    `x-amz-content-sha256:${payloadHash}\n` +
    `x-amz-date:${amzDate}\n`
  const signedHeaders = 'content-type;host;x-amz-content-sha256;x-amz-date'
  const canonicalRequest = `PUT\n${canonicalUri}\n\n${canonicalHeaders}\n${signedHeaders}\n${payloadHash}`
  const stringToSign = `AWS4-HMAC-SHA256\n${amzDate}\n${dateStamp}/${region}/s3/aws4_request\n${CryptoJS.SHA256(canonicalRequest).toString(CryptoJS.enc.Hex)}`
  const kDate = CryptoJS.HmacSHA256(dateStamp, 'AWS4' + secretKey)
  const kRegion = CryptoJS.HmacSHA256(region, kDate)
  const kService = CryptoJS.HmacSHA256('s3', kRegion)
  const kSigning = CryptoJS.HmacSHA256('aws4_request', kService)
  const signature = CryptoJS.HmacSHA256(stringToSign, kSigning).toString(CryptoJS.enc.Hex)
  const authorization =
    `AWS4-HMAC-SHA256 Credential=${accessKey}/${dateStamp}/${region}/s3/aws4_request, SignedHeaders=${signedHeaders}, Signature=${signature}`
  const url = `${protocol}://${host}${canonicalUri}`

  const res = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': contentType,
      'x-amz-content-sha256': payloadHash,
      'x-amz-date': amzDate,
      Authorization: authorization,
    },
    body: newFile,
  })

  if (!res.ok) throw new Error('Upload failed')
  return url
}